import { Box, Typography } from '@mui/material'

interface Props {
  children: string
}

export function DescriptionBox({ children }: Props) {
  return (
    <Box sx={{ whiteSpace: 'pre-line', mt: 1 }}>
      <Typography color="gray" variant="caption1">
        {children}
      </Typography>
    </Box>
  )
}
